import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, InjectionToken, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';

export const IS_MOBILE = new InjectionToken('Returns true if layout is sm or below sm or landscape', {
  factory: (): Signal<boolean> => {
    const breakpointObserver = inject(BreakpointObserver);

    const isHandset$ = breakpointObserver.observe([Breakpoints.Handset]).pipe(map(({ matches }) => matches));
    const isHandsetLandscape$ = breakpointObserver.observe([Breakpoints.HandsetLandscape]).pipe(map(({ matches }) => matches));

    return toSignal(
      combineLatest([isHandset$, isHandsetLandscape$]).pipe(map(([isHandset, isHandsetLandscape]) => isHandset || isHandsetLandscape)),
      {
        initialValue: false,
      }
    );
  },
});
